import React from 'react';

import {DialogProps, Grid, Stack} from '@mui/material';

import {Types} from '@wheeebo/polaris-api';

import GroupMemberListCard from './group/GroupMemberListCard';
import GroupVehicleListCard from './group/GroupVehicleListCard';
import GroupProfileCard from './group/GroupProfileCard';
import DialogBase from './DialogBase';

interface Props extends DialogProps {
  groupId: Types.UUID;
  onMemberSelected: (memberId: Types.UUID) => void;
  onVehicleSelected: (vehicle: Types.UUID) => void;
  onClose: () => void;
}

const GroupDialog = ({groupId, onMemberSelected, onVehicleSelected, onClose, ...props}: Props): JSX.Element => {
  return (
    <DialogBase title="Group" onClose={onClose} {...props}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <Stack gap={1}>
            <GroupProfileCard groupId={groupId} />
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack gap={1}>
            <GroupMemberListCard groupId={groupId} onMemberSelected={onMemberSelected} />
            <GroupVehicleListCard groupId={groupId} onVehicleSelected={onVehicleSelected} />
          </Stack>
        </Grid>
      </Grid>
    </DialogBase>
  );
};

export default GroupDialog;
